import {
  getUserProfileUrl,
  getUserRoleUrl,
  getSystemUrl,
  getAuthTagUrl,
  getUserUrl,
  getUserGroupUsersUrl,
  getIncidentByExecutionIdsUrl,
  getResolveIncidentByIdUrl,
  postIncidentCommentsUrl,
  getUsersListUrl,
  apiBaseUrlConfig,
  getMyProfile,
  changePasswordUrl,
} from "./constants";
import base from "../middlewares/interceptors";
import { ChangePasswordRequest, ChangePasswordResponse } from "../types/auth";

const config = {
  headers: {
    // 'Authorization': 'Bearer my-token',
    "Content-Type": "application/json",
  },
};

export const getUserProfile = async () => {
  try {
    const response = await base.get(getUserProfileUrl, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUserRole = async () => {
  try {
    const response = await base.get(getUserRoleUrl, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getSystem = async () => {
  try {
    const response = await base.get(getSystemUrl, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getAuthTag = async () => {
  try {
    const response = await base.get(getAuthTagUrl, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUsers = async () => {
  try {
    const response = await base.get(getUserUrl, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUsersByGroupId = async (groupId: string | number) => {
  try {
    const response = await base.get(
      `${getUserGroupUsersUrl}/group/${groupId}/users?include_inactive=false&page=1&size=25`,
      config
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};
// export const getUser
export const getPaginatedUsersList = async ({
  page,
  pSize,
  searchTerm,
  email,
  userFilterIds,
  isActive,
  signal,
}: any) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("size", pSize);

    // Add user_filter_ids if provided (comma-separated IDs)
    if (userFilterIds) {
      params.append("user_filter_ids", userFilterIds);
    }

    // Add username filter if searchTerm is provided and has minimum 3 characters
    if (searchTerm && searchTerm.trim().length >= 3) {
      params.append("username", searchTerm.trim());
    }

    // Add email filter if provided
    if (email && email.trim().length > 0) {
      params.append("email", email.trim());
    }

    // Add is_active parameter if not "all"
    if (isActive !== "all") {
      const isActiveBoolean = isActive === "true" ? "true" : "false";
      params.append("is_active", isActiveBoolean);
    }

    const response = await base.get(
      `${getUsersListUrl}/all/pages?${params.toString()}`,
      {
        ...config,
        signal, // Add abort signal for request cancellation
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching paginated users list:", error);
    throw error;
  }
};
export const getUsersList = async () => {
  try {
    const requestUrl = `${getUsersListUrl}`;
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUsersDetails = async () => {
  try {
    const response = await base.get(getUsersListUrl, config);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getIncidentByExecutionIds = async (data: any) => {
  try {
    const formattedData = Array.isArray(data) ? data.join(",\n") : data;
    const apiUrl = `${getIncidentByExecutionIdsUrl}?execution_ids=${formattedData}`;
    const response = await base.get(apiUrl);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getResolveIncident = async (data: any, status: string) => {
  try {
    const response = await base.patch(
      `${getResolveIncidentByIdUrl}/${data}/${status}`,
      config
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const postIncidentComments = async ({ payload }: any) => {
  try {
    const response = await base.post(`${postIncidentCommentsUrl}`, payload);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

// User CRUD Operations
export const getUserById = async (id: string | number) => {
  try {
    const response = await base.get(`${getUsersListUrl}/${id}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUser = async (id: string | number, payload: any) => {
  try {
    const response = await base.put(
      `${getUsersListUrl}/${id}`,
      payload,
      config
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteUser = async (id: string | number) => {
  try {
    const response = await base.delete(`${getUsersListUrl}/${id}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// User Assignment Update Operations
export const updateUserRoles = async (
  userId: string | number,
  roleIds: number[]
) => {
  try {
    const payload = {
      user_id: Number(userId),
      role_ids: roleIds,
    };
    const response = await base.post(
      `${apiBaseUrlConfig}/user-user-roles/update-roles`,
      payload,
      config
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUserAuthTags = async (
  userId: string | number,
  authTagIds: number[]
) => {
  try {
    const payload = {
      user_id: Number(userId),
      auth_tag_ids: authTagIds,
    };
    const response = await base.post(
      `${apiBaseUrlConfig}/user-auth-tags/update-auth-tags`,
      payload,
      config
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUserSystems = async (
  userId: string | number,
  systemIds: number[]
) => {
  try {
    const payload = {
      user_id: Number(userId),
      system_ids: systemIds,
    };
    const response = await base.post(
      `${apiBaseUrlConfig}/user-systems/update-systems`,
      payload,
      config
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const myProfile = async () => {
  try {
    const response = await base.get(`${getMyProfile}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// User Activation/Deactivation Operations
export const activateUser = async (id: string | number) => {
  try {
    const response = await base.put(
      `${getUsersListUrl}/${id}/reactivate`,
      {},
      config
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deactivateUser = async (id: string | number) => {
  try {
    const response = await base.delete(`${getUsersListUrl}/${id}`, config);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const changePassword = async (
  payload: ChangePasswordRequest
): Promise<ChangePasswordResponse> => {
  const response = await base.put(changePasswordUrl, payload, config);
  return response?.data;
};
